var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssesment3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 95,
    viewBox: "0 0 92 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0045166 93.9976C28.9995 93.9976 52.5045 70.4925 52.5045 41.4976H0.0045166V93.9976Z",
    fill: "#3498DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5045 41.5C52.5045 12.5051 76.0096 -11 105.005 -11L105.005 41.5L52.5045 41.5Z",
    fill: "#3498DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 41.5017C23.5051 41.5017 4.10975e-06 17.9967 9.17939e-06 -10.9983L52.5 -10.9983L52.5 41.5017Z",
    fill: "#3498DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.99 94.0017C104.99 65.0068 81.4853 41.5017 52.4904 41.5017L52.4904 94.0017L104.99 94.0017Z",
    fill: "#3498DB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssesment3);
export default __webpack_public_path__ + "static/media/assesment-3.d5779dbc206a396100f6085333497a90.svg";
export { ForwardRef as ReactComponent };